<template>
  <div class="news_details_wrap news-detail-page">
    <PCNavbar selectIndex="4-2"/>
    <MobileNavBar :currentActive="3"/>
    <div class="news_content">
      <el-breadcrumb class="news_bread" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>

      <article class="news_article">
        <header class="news_article_header">
          <h1 class="news_title">
            济南静态交通集团领导来我司开展指导工作
          </h1>
          <div class="news_meta">
            <span class="news_meta_item">来源：山东智能工业装备公司</span>
            <span class="news_meta_sep">·</span>
            <span class="news_meta_item">投稿时间：2026-04-23</span>
          </div>
        </header>

        <div class="article_body">
          <p class="lead">
            2026年4月23日下午，济南静态交通集团张总、周总、邓总三位领导莅临山东智能工业装备公司开展指导工作，公司相关负责人全程陪同，双方围绕合作事宜开展深入交流。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img1"
              alt="来访交流现场"
            >
            <figcaption class="figure_caption">来访交流</figcaption>
          </figure>

          <h2 class="section_title">一、公司情况及相关业务展示</h2>

          <p class="body_paragraph">
            1. 殷海波总向三位来访领导详细介绍了厂区整体布局、基础设施建设及运营管理等情况，让来访领导对公司厂区有了全面了解。
          </p>

          <p class="body_paragraph">
            2. 赵吉老师依次展示了低速两轮充电桩、直流充电桩、充电堆及负载设备的详细技术参数，同时对制造车间的区域划分、生产流程、设备配置等情况进行了细致讲解，直观呈现了公司产品实力及生产能力。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img2"
              alt="产品与技术讲解展示"
            >
            <figcaption class="figure_caption">产品与制造讲解</figcaption>
          </figure>

          <p class="body_paragraph">
            3. 殷海波总进一步介绍了山东智能工业装备公司的企业文化核心理念、发展历程及整体业务布局、核心优势，其专业的讲解和公司扎实的发展基础，得到了来访领导的高度认可。
          </p>

          <p class="body_paragraph">
            4. 李慧都老师重点介绍了公司新能源事业部与软件事业部的核心业务、典型合作案例，展现了公司在相关领域的技术积累和服务能力。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img3"
              alt="业务与合作案例交流"
            >
            <figcaption class="figure_caption">业务与合作案例</figcaption>
          </figure>

          <h2 class="section_title">二、济南静态交通集团重点关注方向</h2>

          <p class="body_paragraph">
            济南静态交通集团张总结合行业发展现状与自身业务需求，介绍了集团当前重点关注的两大方向。
          </p>
          <p class="body_paragraph">
            1. <strong>非机动车治理</strong>。围绕各地铁出入口规划建设非机动车专属停放区，并配套部署两轮充电桩等设施，规范停放秩序、提升便民服务水平。
          </p>
          <p class="body_paragraph">
            2. <strong>安全服务保障</strong>。坚持安全优先，为公众提供安全、便捷、高效的两轮车充电服务，切实防范充电环节的安全隐患。
          </p>

          <h2 class="section_title">三、双方初步达成的合作意向</h2>

          <p class="body_paragraph">
            1. 由济南静态交通集团提供相关技术参数标准，山东智能工业装备公司承接两轮充电桩代工业务，代工过程中严格按照标准把控产品安全与质量，确保产品符合使用需求。
          </p>

          <p class="body_paragraph">
            2. 山东智能工业装备公司为济南静态交通集团专属研发电池健康监测功能模块，实现对两轮车电池健康状况的实时监测与数据反馈，助力提升充电安全保障能力。
          </p>

          <p class="body_paragraph">
            3. 在两轮车充电桩配套区域开展共享充电设备试点工作，增设手机应急充电功能，用户通过扫码即可开启充电服务，有效解决群众出行中手机应急充电的需求。
          </p>

          <figure class="figure_block figure_block--end">
            <img
              class="article_img"
              :src="images.img4"
              alt="双方洽谈与合作展望"
            >
            <figcaption class="figure_caption">洽谈与合作展望</figcaption>
          </figure>
        </div>
      </article>
    </div>

    <div class="news_detail_page_foot">
      <CallMe/>
      <MobileCallme/>
    </div>
  </div>
</template>

<script>
import PCNavbar from '@/components/report_list/SpaNav.vue'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'

export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CallMe,
    MobileCallme,
  },
  data () {
    return {
      images: {
        img1: require('@/assets/images/news-list/news1/image1.jpg'),
        img2: require('@/assets/images/news-list/news1/image2.jpg'),
        img3: require('@/assets/images/news-list/news1/image3.jpg'),
        img4: require('@/assets/images/news-list/news1/image4.jpg'),
      },
    }
  },
}
</script>

<style lang="scss">
@import '~@/assets/styles/news-detail-responsive.scss';
</style>
